<c-card class="mb-5">
  <c-card-header>
    <!-- <app-date-to-date-search></app-date-to-date-search> -->
    <div class="d-flex justify-content-between align-items-center py-2">
      <c-button-group class="btn btn-primary" role="group">

        <button cButton class="btn-primary" (click)="handleDoc('xls')">
          XLS
        </button>
      </c-button-group>
    </div>
  </c-card-header>
  <c-card-body>
    <!-- <div class="d-flex justify-content-end p-3"></div> -->
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 responsive-table">



        <ng-container matColumnDef="createdAt" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('status')">
              createdAt
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'createdAt'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field>
              <input matInput [matDatepicker]="picker" (dateInput)="onDateChange($event, 'createdAt')"
                (dateChange)="onDateChange($event, 'createdAt')" placeholder="MM/DD/YYYY" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.createdAt | date:'medium' }}
          </td>
        </ng-container>


        <ng-container matColumnDef="userCode">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('userCode')">
              User Code
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'identifier'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'userCode')">
              <input matInput placeholder="Search" />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.userCode }}
          </td>
        </ng-container>
        <ng-container matColumnDef="phoneNo">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('phoneNo')">
              Phone No
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'identifier'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'phoneNo')">
              <input matInput placeholder="Search"  />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.phoneNo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('name')">
              Name
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'identifier'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'name')">
              <input matInput placeholder="Search"  />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="transactionId" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name" (click)="sortData('transactionId')">
              TransactionId
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.transactionId ? element.transactionId: '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="coinCurrentPrice" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              CoinCurrentPrice
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.coinCurrentPrice ? element.coinCurrentPrice: '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="coinValue" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              coinValue
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.coinValue }}
          </td>
        </ng-container>
        <ng-container matColumnDef="reward" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              Reward
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.reward }}
          </td>
        </ng-container>
        <ng-container matColumnDef="totalCoinvalue" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              TotalCoinvalue
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.totalCoinvalue }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fiatAmount" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              fiatAmount
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.fiatAmount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="adminActionDate" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              adminActionDate
              <div class="nofilter"></div>
              <!-- <mat-icon class="sorting-icon" *ngIf="sorting.column === 'createdAt'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon> -->
            </div>
            <!-- <mat-form-field>
              <input matInput [matDatepicker]="picker" (dateInput)="onDateChange($event, 'adminActionDate')"
                (dateChange)="onDateChange($event, 'createdAt')" placeholder="MM/DD/YYYY" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field> -->
          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.adminActionDate | date:'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="approvedBy" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              Approve By
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.approvedBy }}
          </td>
        </ng-container>


        <ng-container matColumnDef="status" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name ">
              Status
              <div class="nofilter"></div>
            </div>

          </th>
          <td mat-cell *matCellDef="let element">

            {{ element.status }}
          </td>
        </ng-container>
        <ng-container matColumnDef="action" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-name">Action</div>
            <div class="nofilter"></div>
          </th>
          <td mat-cell *matCellDef="let element">
            <i class="cil-search cursor-pointer" (click)="redirecttodetails(element._id)"
              matTooltip="Click to view withdraw details"></i>

          </td>
        </ng-container>
        <ng-container matColumnDef="withdrawRequestDate" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              withdrawRequestDate
              <div class="nofilter"></div>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.withdrawStatus === 'new' ? '--' : (element.withdrawRequestDate | date:'medium') }}
            <!-- {{ element.withdrawRequestDate | date:'medium' }} -->
          </td>
        </ng-container>
        <ng-container matColumnDef="withdrawStatus" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name ">
              Approve Withdraw
              <div class="nofilter"></div>
            </div>

          </th>
          <!-- <td mat-cell *matCellDef="let element">
            {{ element.withdrawStatus === 'new' ? '--' : (element.withdrawStatus) }}
          </td> -->
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.withdrawStatus === 'requested' && isEligibleForAction(element.adminActionDate)">{{element.withdrawStatus}}
              <i class="cil-send custom-icon text-info"
                 (click)="navigateApporveWithdraw(element._id)"
                 matTooltip="Click to withdraw">
              </i>
            </span>
            <span *ngIf="!(element.withdrawStatus === 'requested' && isEligibleForAction(element.adminActionDate))">
              <!-- {{ element.withdrawStatus }} -->
              {{ element.withdrawStatus === 'new' ? '--' : (element.withdrawStatus) }}
            </span>
          </td>

        </ng-container>
        <ng-container matColumnDef="withdrawApproveDate" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name">
              withdrawApproveDate
              <div class="nofilter"></div>
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.withdrawStatus === 'new' ? '--' : (element.withdrawApproveDate | date:'medium') }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ 'hide-data': isLoading }"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="9999" class="p-4">
            <strong class="text-secondary">No record found!</strong>
          </td>
        </tr>
      </table>
      <div *ngIf="isLoading" class="spinner-container">
        <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
        </mat-progress-spinner>
      </div>
    </div>
    <mat-paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" showFirstLastButtons aria-label="Select page of periodic elements"
      (page)="pageChanged($event)">
    </mat-paginator>
  </c-card-body>
</c-card>
